// https://annuities.myaccount.pacificlife.com/enroll-ui/client
import React from "react";
import Modal from "react-modal";
import "react-datepicker/dist/react-datepicker.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

const TermsAndConditions = (params) => {
    console.log(params.TermsAndConditionsOpen);
    const PL_LOGO_BLACK_URL =
        "https://www.pacificlife.com/content/dam/paclife/crp/images/logos/PL_logo_horizontal_RGB_black.svg";
    return (
        <>
            <Modal isOpen={params.TermsAndConditionsOpen}>
                <div>
                    <div style={{ borderBottom: "2px solid black" }}>
                        <Row>
                            <Col sm={6}>
                                <h2>Terms and Conditions</h2>
                            </Col>
                            <Col sm={6} style={{ textAlign: "right" }}>
                                <Button
                                    variant="primary"
                                    onClick={() =>
                                        params.CloseTermsAndConditions(false)
                                    }
                                >
                                    Close
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <p>
                        Please carefully read this notice before you use the
                        Lifeline Website. If you do not agree with the following
                        conditions of use, please exit this Website. By using
                        this Website, you signify that you agree to these terms
                        of use.
                    </p>
                    <p>
                        <h4>Website Content</h4>
                        Pacific Life Insurance Company ("Pacific Life") created
                        this Website for the use of its appointed life insurance
                        producers. The Website does not, and it is not intended
                        to, provide any financial, insurance, legal, accounting,
                        or tax advice, and shall not be relied upon by you in
                        that regard. The Website shall not be used, or relied
                        upon by you, as a substitute for your independent
                        research or professional advice that is provided to you
                        in direct consultation with a Pacific Life
                        representative.
                    </p>
                    <p>
                        The information, text, graphics and links provided in
                        this Website are provided by Pacific Life as a
                        convenience to you, our appointed life insurance
                        producers. Pacific Life will use reasonable efforts to
                        include accurate and up-to-date information. However,
                        due to the nature of the Internet, Pacific Life does not
                        warrant and cannot guarantee the accuracy, completeness
                        or authenticity of the information contained in this
                        Website, or the information, text, graphics, links,
                        Website functionality, and other items contained on this
                        server or its suitability for any purpose.
                    </p>
                    <p>
                        Pacific Life does not warrant that the functions
                        contained in the materials will be uninterrupted or
                        error-free, that defects will be corrected, or that this
                        Website or the server that makes it available is free of
                        viruses or other harmful components as such information
                        is received by you because Pacific Life cannot control
                        the transmission of information over this medium.
                        Pacific Life does not warrant or make any
                        representations regarding the use of, or the results of
                        the use of, the materials on this site, or your
                        transmission of any software, data or information from
                        the Website to you.
                    </p>
                    <p>
                        Information provided on this Website is believed to be
                        reliable when posted. However, we cannot guarantee that
                        information will be accurate, complete and current at
                        all times. This Website could include technical
                        inaccuracies or typographical errors. Pacific Life will
                        from time to time revise the information, products and
                        services described in this Website, and reserves the
                        right to make such changes without notice.
                    </p>
                    <p>
                        <h4>Liability</h4>
                        The use of this Website is entirely at your risk. The
                        materials and information in this Website (including
                        text, graphics, and functionality) are presented without
                        express or implied warranties of any kind and are
                        provided "as is". It is your responsibility to evaluate
                        the accuracy, completeness and usefulness of any
                        opinions, advice, services or other information
                        provided.
                    </p>
                    <p>
                        Pacific Life intends for the information contained in
                        this Website to be accurate and reliable. However,
                        errors sometimes occur. Therefore, Pacific Life to the
                        full extent permitted by applicable laws disclaims all
                        warranties, express or implied, including, but not
                        limited to, implied warranties of merchantability and
                        fitness for a particular purpose as to any matter
                        whatsoever relating to this Website or the information
                        contained herein.
                    </p>
                    <p>
                        To the full extent permitted by applicable laws, in no
                        event shall Pacific Life, its agents, employees,
                        directors, and officers be liable for any damages of any
                        kind caused to any person as a consequence of the use of
                        this Website including but not limited to any direct,
                        special, incidental, indirect or consequential damages
                        of any kind including but not limited to loss of use,
                        loss of data or loss of profits, whether or not advised
                        of the possibility of such damage, or based upon any
                        theory of liability, arising out of or in connection
                        with the use or performance of this Website or the
                        information contained herein. We will not be responsible
                        for any detrimental reliance that you may place upon the
                        Website or its contents.
                    </p>
                    <p>
                        <h4>Life Insurance Product Availability</h4>
                        Unless otherwise specified, the materials in the Website
                        are presented solely for the purpose of educating the
                        user about the products and services of Pacific Life’s
                        Life Insurance Division. Nothing in this Website
                        constitutes an offer to buy or sell products or services
                        of Pacific Life Pacific Life makes no representation
                        that any or all of the materials in the Website are
                        appropriate or available for sale in any or all
                        locations. Not all products and services described are
                        available in all states of the U.S. or the world. No
                        life insurance, security or other product offered by
                        Pacific Life is offered or will be sold in any
                        jurisdiction in which such offer or solicitation,
                        purchase or sale would be unlawful under the insurance
                        or securities laws or other laws of such jurisdiction.
                        No such security or product is offered or will be sold
                        in any jurisdiction by an entity which is not properly
                        licensed to do so in such jurisdiction. Some products
                        may not be available in all states. In addition, any
                        prospectus information available on this Website is
                        posted for informational purposes only.
                    </p>
                    <p>
                        Those who choose to access this Website do so on their
                        own initiative and are responsible for compliance with
                        state, local and foreign laws, if and to the extent such
                        laws are applicable.
                    </p>
                    <p>
                        The life insurance and variable life insurance products
                        referred to in this Website may be offered and sold only
                        to persons in the United States. Variable life insurance
                        products are distributed by{" "}
                        <b>Pacific Select Distributors, Inc.</b>, (member{" "}
                        <a target="_blank" href="http://www.finra.org/">
                            FINRA
                        </a>{" "}
                        &{" "}
                        <a target="_blank" href="http://www.sipc.org/">
                            SIPC
                        </a>
                        ), a subsidiary of Pacific Life.
                    </p>
                    <p>
                        <h4>Copyright</h4>
                        This Website is provided for the personal viewing of our
                        life insurance producers and Pacific Life maintains all
                        copyrights in the text, buttons, layouts, graphic images
                        and logos contained in this Website. Except as stated
                        herein, no portion of this Website or its contents may
                        be reproduced, copied, republished, altered, or
                        transmitted, uploaded, downloaded, or posted in any form
                        or by any means, electronic, mechanical, photocopying,
                        recording, or otherwise, without the prior written
                        permission of Pacific Life Insurance Company.
                    </p>
                    <p>
                        Modification of the materials or use of the materials
                        for any other purpose is a violation of Pacific Life's
                        copyright and other proprietary rights. The use of any
                        such material on any other Website or networked computer
                        environment is prohibited.
                    </p>
                    <p>
                        You may print a copy of the information contained herein
                        for your personal use only, but you may not reproduce or
                        distribute the text or graphics to others or
                        substantially copy the information on your own server,
                        or link to this Website, without prior written
                        permission of Pacific Life Insurance Company.
                    </p>
                    <p>
                        An acknowledgment of the source must be included
                        whenever our materials are copied or published. Any
                        infringement of our rights will result in appropriate
                        legal action. Pacific Life disclaims any and all
                        liability which may result from any unauthorized
                        reproduction or use of the information on this site.
                    </p>
                    <p>
                        <h4>License and Reproduction</h4>
                        Permission is granted to print copies of portions of
                        this Website, but not the entire Website, and to display
                        and navigate around this Website with a computer using
                        HTML browser software, solely for personal, non-public
                        use. Any commercial or public use of this Website or any
                        portion hereof is strictly prohibited. Permission is
                        also granted, on a non-exclusive basis, until Pacific
                        Life gives notice to the contrary, to include a link to
                        the Uniform Resource Locator (URL) of this Website in
                        HTML documents which you prepare, subject to the
                        following conditions: (a) the URL may be used only for
                        the purpose of hyperlinking to Pacific Life's Lifeline
                        home page at "
                        <a href="http://lifeline.pacificlife.com/">
                            http://lifeline.pacificlife.com/
                        </a>
                        "; (b) the URL shall be clearly identified as being a
                        link to a Website owned and operated by Pacific Life or
                        its affiliated companies; and (c) you will make no other
                        use of any Pacific Life intellectual property, other
                        than the URL, without Pacific Life Insurance Company's
                        express written permission.
                    </p>
                    <img
                        height={200}
                        width={200}
                        alt="Pacific Life Logo"
                        src={PL_LOGO_BLACK_URL}
                    />
                    <p>
                        <h4>Trade Marks</h4>
                        The logo shown here for Pacific Life is a registered
                        trade mark of Pacific Life Insurance Company. Unless
                        otherwise indicated, all trademarks, service marks, and
                        trade names are proprietary to Pacific Life or its
                        affiliates. Pacific Life enforces its intellectual
                        property rights. Use in commerce other than as "fair
                        use" is prohibited by law except by express license from
                        Pacific Life.
                    </p>
                    <p>
                        Other parties' trademarks and service marks that may be
                        referred to herein are the property of their respective
                        owners.
                    </p>
                    <p>
                        <h4>Viruses</h4>
                        Because of the marked increase in the fabrication and
                        proliferation of computer viruses affecting the
                        Internet, we want to warn you about infections or viral
                        contamination on your system. It is your responsibility
                        to scan any and all downloaded materials received from
                        the Internet. Pacific Life is not responsible or liable
                        for any damage caused by such hazards.
                    </p>
                    <p>
                        Pacific Life companies cannot and do not guarantee or
                        warrant that files available for downloading from this
                        Website are free of viruses, worms, Trojan horses or
                        other code that has contaminating or destructive
                        properties. Pacific Life companies do not make any
                        express or implied warranties, representations or
                        endorsements whatsoever (including without limitation
                        warranties of title, non-infringement or fitness for a
                        particular purpose) with respect to the files available
                        for downloading from this site. In no event will Pacific
                        Life be liable to you or to anyone else for any decision
                        made or action taken by you or anyone else in reliance
                        on results obtained from use of files downloaded from
                        this site.
                    </p>
                    <p>
                        <h4>Security</h4>
                        To protect information, Pacific Life uses three layers
                        of security: Users are required to login using a unique
                        user ID and password. Each user ID and corresponding
                        password can only be used by one individual user. The
                        user agrees to assume sole responsibility for the
                        security of their user ID and password. If the user
                        believes that any user ID and/or password are being used
                        by someone other than an authorized user, the user must
                        notify Pacific Life immediately.
                    </p>
                    <ul>
                        <li>
                            A firewall (a combination of computer hardware and
                            software) keeps unauthorized users from accessing
                            information within Pacific Life’s computer network.
                        </li>
                        <li>
                            Encryption technology is used to secure data when
                            it’s being transferred from one computer to another.
                        </li>
                    </ul>
                    <p>
                        The information submitted in connection with Lifeline is
                        protected through encryption technology. However, all
                        other information submitted to Pacific Life, including
                        electronic mail inquiries, is submitted through the
                        Internet, which is an unsecured, public network.
                    </p>
                    <p>
                        Actual or attempted unauthorized use of the Site may
                        result in criminal and/or civil prosecution. Pacific
                        Life reserves the right to view, monitor, and record
                        activity on the Site without notice or permission from
                        the user. Any information obtained by monitoring,
                        reviewing, or recording is subject to review by law
                        enforcement organizations in connection with
                        investigation or prosecution of possible criminal
                        activity on the Site. Pacific Life will comply with all
                        court orders involving requests for such information.
                    </p>
                    <p>
                        You acknowledge and confirm that the Internet is not a
                        secure medium where privacy can be ensured, and that
                        complete security and confidentiality over the Internet
                        is not possible at this time. Your confidential use of
                        the Website cannot be guaranteed and you acknowledge
                        that your use of the Website (including information you
                        transmit to the Website) may be subject to access by, or
                        disclosure to, other persons. Without limiting any other
                        disclaimer herein, Pacific Life shall not be responsible
                        or liable for any harm that you or any other person may
                        suffer in connection with any such breach of
                        confidentiality or security.
                    </p>
                    <p>
                        <h4>Linked Websites</h4>
                        Other Internet or Websites which may provide access to
                        this Website by hypertext links ("hyperlinks") are
                        entirely independent of this Website. Links to other
                        Internet or Websites from this Website are included as a
                        convenience for our visitors and in no way are meant to
                        imply that Pacific Life endorses, sponsors, promotes or
                        is affiliated with the owners of or participants in
                        those sites, or endorses any information contained on
                        those sites, unless expressly stated. Pacific Life does
                        not guarantee the accuracy of any information in these
                        other sites nor does it assume any liability for the
                        content or presentation of linked sites.
                    </p>
                    <p>
                        Pacific Life cannot guarantee that the hyperlinks set
                        out on our Website will be accurate at the time of your
                        access. Moreover, the sites pointed at by hyperlinks
                        have been independently developed and possibly
                        maintained by person(s) over whom Pacific Life has no
                        control. Pacific Life cannot and does not monitor the
                        sites linked to its pages on the Internet or any
                        transmission made through the respective web pages and
                        news groups. Accordingly, Pacific Life assumes no
                        responsibility for the content of any site referenced to
                        by any hyperlink or otherwise. Pacific Life believes
                        that our making available hyperlinks to publicly
                        accessible web pages is legally permissible and
                        consistent with the common, customary expectations of
                        those who make use of the Internet.
                    </p>
                    <p>
                        <h4>Privacy</h4>
                        <i>Effective 7/1/2004</i>
                        <br />
                        Information provided by you through our Websites is used
                        only to help transact the business you have with us.
                    </p>
                    <p>
                        Privacy is a top priority at Pacific Life. We are
                        committed to maintaining the highest level of
                        confidentiality with all of the information we receive
                        through our Websites.
                    </p>
                    <p>
                        You are not required to provide personal information to
                        use Pacific Life Websites except where expressly stated.
                        Certain features may require you to submit personal
                        information in order for those features to function
                        (e.g. First Time User login). Such information might
                        include first and last name, a physical address, an
                        email address, a telephone number, and social security
                        number.
                    </p>
                    <p>
                        Personal information may be disclosed to other entities
                        that provide business services to us related to our
                        transactions with you. This includes administrative,
                        claims, or audit services. Examples are your agent,
                        broker, or a reinsurance company. Before we disclose
                        your information, these entities must agree to keep it
                        private.
                    </p>
                    <p>
                        We may also share information within our corporate
                        family to service your business. For example, our
                        business units provide administrative services, policy
                        document preparation and delivery, and claims
                        processing.
                    </p>
                    <p>
                        If necessary, we disclose information when it is
                        required by law. An example is a routine filing to the
                        Internal Revenue Service (such as a Form 1099). We may
                        also disclose certain information to other entities to
                        help us report or prevent fraud. Examples are reports to
                        a regulatory or law enforcement agency.
                    </p>
                    <p>
                        Generally, you have the right to review the personal
                        information we have about you. You must request this in
                        writing. We will not disclose information we have
                        collected in connection with a claim or lawsuit. If you
                        believe that any of the information we have is in error,
                        you may write us and request a correction. Where
                        justified, corrections will be made.
                    </p>
                    <p>
                        Pacific Life and representatives are committed to
                        respecting the privacy of your personal information.
                    </p>
                    <p>
                        The portions of our Websites that require you to input
                        personal information employ the most current encryption
                        technology available to ensure secure transmission of
                        your information. However, if you are concerned about
                        the security of the Internet for the communication of
                        personal information, you may consider using alternative
                        forms of communication such as telephone, fax, or
                        regular mail.
                    </p>
                    <p>
                        Please review this Online Privacy Policy frequently as
                        it may change at any time at Pacific Life’s sole
                        discretion.
                    </p>
                    <p>
                        <h4>Governing Laws</h4>
                        The applicable laws of the state of California shall
                        govern as to the interpretation, validity and effect of
                        this Agreement and any use of the Website, without
                        giving effect to any principles of conflicts of law. If
                        any provision of this agreement shall be unlawful, void,
                        or for any reason unenforceable, then that provision
                        shall be deemed severable from this agreement and shall
                        not affect the validity and enforceability of any
                        remaining provisions. You hereby consent and submit to
                        the non-exclusive jurisdiction of the courts of the
                        state of California in any action or proceeding
                        instituted under or related to this Agreement or your
                        use of this Website.
                    </p>
                    <p>
                        <h4>Service Request Forms</h4>
                        Any information requested is for our internal use to
                        service your request, so that we may access your
                        customer information. It is not shared with any third
                        party, unless permitted by you or required by law.
                    </p>
                    <p>
                        <h4>Interactive Forms or Calculators</h4>
                        Any interactive forms or calculators on this Website are
                        there for your information only. Pacific Life tracks,
                        retains and/or uses any of the data input into these
                        forms for our internal use only.
                    </p>
                    <p>
                        <h4>Aggregated Tracking Information</h4>
                        This Pacific Life Website collects no personally
                        identifying information about individuals except when
                        specifically and knowingly provided by such individuals.
                        Pacific Life will not release any of said information
                        about you without your permission, unless permitted or
                        required by law.
                    </p>
                    <p>
                        Pacific Life gathers two types of information about
                        people who visit our site: data you provide through
                        optional, voluntary contact request forms; and
                        aggregated tracking information such as IP address and
                        home server information.
                    </p>
                    <p>
                        To enable us to continually improve on the content we
                        offer our users, as well as for systems administration
                        purposes, we collect aggregate information site-wide.
                        This gives us an idea of which parts of our Website
                        users are visiting. We do not link IP addresses to
                        anything personally identifiable, which means a user’s
                        session will be tracked, but the user will be anonymous.
                    </p>
                    <p>
                        <h4>Information Collection and Use</h4>
                        Pacific Life routinely gathers data on Website activity,
                        such as information about Website visitors, to improve
                        the caliber of online information and services offered.
                        There are two forms of data that Pacific Life collects:
                        Website visitorship data and personal information
                        voluntarily provided to us by Website visitors.
                    </p>
                    <p>
                        Website visitorship data is (1) collected on an
                        aggregate, anonymous basis, which means no personal
                        information is associated with this data; (2) gathered
                        through the use of Web server logs and cookies. A Web
                        server log is a file where Website activity is stored. A
                        cookie is a small piece of information that a Website
                        sends to a visitor’s computer, which is stored on his or
                        her hard drive. Pacific Life uses cookies to track
                        repeat visits to its Website. Although Pacific Life
                        assigns a cookie to a visitor’s computer, the company
                        does not know who that visitor is unless that person
                        specifically tells us; and (3) shared among Pacific Life
                        business units to improve Website content and overall
                        service.
                    </p>
                    <p>
                        <h4>Submissions</h4>
                        Pacific Life welcomes your comments regarding our
                        Website. While we do value your feedback, we ask that
                        you not submit to us any suggestions, materials, ideas
                        or creative concepts for new, modified or different
                        products or services via this Website. Pacific Life
                        requests this in order to avoid confusion in the future
                        regarding the origin of the concept, product or service.
                    </p>
                    <p>
                        If, despite our request that you not send us any
                        creative materials, you in fact send us creative
                        suggestions, ideas, concepts or other information
                        (collectively, the Information), such Information shall
                        be deemed by Pacific Life to be, and shall remain, the
                        property of Pacific Life. None of the Information shall
                        be subject to any obligation of confidence on the part
                        of Pacific Life and Pacific Life shall not be liable for
                        any use or disclosure of any Information. Without
                        limiting the foregoing, Pacific Life shall exclusively
                        own all rights to the Information of every kind and
                        nature and shall be entitled to unrestricted use of the
                        Information for any purpose whatsoever, commercial or
                        otherwise, without compensation to the provider of the
                        Information.
                    </p>
                    <p>
                        <h4>Other Service Mark/Trademark Information</h4>
                        Adobe and Acrobat are trademarks of Adobe Systems
                        Incorporated and are used with permission from Adobe
                        Systems Incorporated.
                        <br />
                        Real Audio is a trademark of RealNetworks, Inc. and is
                        used with permission from RealNetworks, Inc.
                    </p>
                    <p>
                        Microsoft, Windows, Windows NT, MSN, The Microsoft
                        Network and/or other Microsoft products referenced
                        herein are either trademarks or registered trademarks of
                        Microsoft Corporation and are used with permission from
                        Microsoft Corporation.
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default TermsAndConditions;
